const ORCHESTRATOR_URL = process.env.ORCHESTRATOR_URL || "/orchestrator";
export async function getMobileThemePreference(deviceSessionToken) {
    const response = await fetch(`${ORCHESTRATOR_URL}/preferences/mobile-theme`, {
        headers: { Authorization: `Bearer ${deviceSessionToken}` },
        cache: "no-store",
    });
    if (!response.ok)
        throw new Error(`mobile_theme_load_${response.status}`);
    const body = await response.json();
    return body.preference || null;
}
export async function saveMobileThemePreference(deviceSessionToken, preference) {
    const response = await fetch(`${ORCHESTRATOR_URL}/preferences/mobile-theme`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${deviceSessionToken}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(preference),
    });
    if (!response.ok)
        throw new Error(`mobile_theme_save_${response.status}`);
}
